import {
  LOGIN_USER,
  LOGOUT_USER
} from '../actions';
import { authType, authParams } from "../../config/defaultValues";


export const loginUser = (user, history, redirect = true) => {
  localStorage.setItem('user_admin', JSON.stringify(user));
  global.user = user;
  if (redirect) setTimeout(() => { history.push('/'); }, 500)
  return (
    {
      type: LOGIN_USER,
      payload: user
    }
  )
}

export const logoutUser = (history) => {
  if (authType === 2) window.location.href = authParams.Path + '/auth/core/connect/endsession?id_token_hint=' + localStorage.getItem('id_token') + '&post_logout_redirect_uri=' + document.location.origin;

  let keys = Object.keys(localStorage);
  let items = keys.filter(e => ['__theme_color', '__current_locale', 'countryCode', 'mobileNumber'].indexOf(e) === -1)
  items.forEach(item => localStorage.removeItem(item))

  return (
    {
      type: LOGOUT_USER,
      payload: { history }
    }
  )
}